var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 145 145",
    style: {
      enableBackground: "new 0 0 145 145"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "women_1"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#60B0C9"
    },
    width: 145,
    height: 145
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#5A3017"
    },
    cx: 86.95,
    cy: 81.002,
    rx: 16.518,
    ry: 18.002
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M109.374,115.396c-4.964-9.397-36.874-15.293-36.874-15.293s-31.911,5.896-36.875,15.293 C31.958,128.434,28.888,145,28.888,145H72.5h43.611C116.112,145,114.04,127.237,109.374,115.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M72.501,100.103c0,0,31.91,5.896,36.874,15.293c4.665,11.842,6.737,29.604,6.737,29.604H72.501 V100.103z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.813,
    y: 81.002,
    style: {
      fill: "#F1C9A5"
    },
    width: 17.374,
    height: 29.077
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.501,
    y: 81.002,
    style: {
      fill: "#E4B692"
    },
    width: 8.686,
    height: 29.077
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#DDAC8C",
      enableBackground: "new"
    },
    d: "M63.813,94.475c1.563,4.485,7.868,7.057,12.499,7.057 c1.676,0,3.306-0.28,4.875-0.795V81.002H63.813V94.475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M94.837,62.652c0-18.161-10.001-28.489-22.337-28.489c-12.337,0-22.338,10.328-22.338,28.489 c0,18.162,10.001,32.888,22.338,32.888S94.837,80.814,94.837,62.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M91.438,75.245c-4.049-0.451-6.783-5.088-6.098-10.353c0.678-5.269,4.513-9.179,8.563-8.733 c4.047,0.449,6.777,5.084,6.094,10.353C99.318,71.781,95.487,75.689,91.438,75.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M45.161,66.513c-0.684-5.269,2.047-9.903,6.092-10.353c4.053-0.446,7.888,3.464,8.567,8.733 c0.683,5.265-2.053,9.901-6.1,10.353C49.671,75.689,45.84,71.781,45.161,66.513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M94.837,62.652c0-18.161-10.001-28.489-22.337-28.489V95.54 C84.837,95.54,94.837,80.814,94.837,62.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9E1F63"
    },
    d: "M109.374,115.396c-1.665-3.154-6.369-5.909-11.878-8.184c-2.77,11.233-12.908,19.566-24.996,19.566 c-12.089,0-22.227-8.333-24.997-19.566c-5.509,2.274-10.212,5.029-11.878,8.184C31.958,128.434,28.888,145,28.888,145H72.5h43.611 C116.112,145,114.04,127.237,109.374,115.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A3017"
    },
    d: "M102.039,65.792c0,0-12.06,6.029-20.501-10.855c-5.628,0.805-22.513-2.411-25.729-10.451 c-2.813,12.06-10.753,14.435-4.824,26.531c4.37,8.916,3.618,24.523,3.618,24.523S36.334,78.865,38.994,56.126 c2.994-25.604,9.178-32.544,17.619-30.133c6.835-8.844,27.738-7.638,36.181,3.217c8.441,10.854,6.064,15.653,9.245,20.1 C108.134,57.831,102.039,65.792,102.039,65.792z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#9E1F63",
      strokeWidth: 1.0637,
      strokeMiterlimit: 10
    },
    points: "47.503,107.212 90.388,119.538  101.22,112.105 97.497,107.212 48.921,119.538 56.013,125.224 97.852,116.218 79.946,127.707 48.212,112.991  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.810befab8e6e5009e146d4ad530c60d0.svg";
export { ForwardRef as ReactComponent };